{
  "Accessibility Menu": "Menu Truy cập",
  "Reset settings": "Đặt lại cài đặt",
  "Close": "Đóng",
  "Content Adjustments": "Điều chỉnh Nội dung",
  "Adjust Font Size": "Điều chỉnh Kích thước Font chữ",
  "Highlight Title": "Đánh dấu Tiêu đề",
  "Highlight Links": "Đánh dấu Liên kết",
  "Readable Font": "Font chữ Dễ đọc",
  "Color Adjustments": "Điều chỉnh Màu sắc",
  "Dark Contrast": "Tương phản Tối",
  "Light Contrast": "Tương phản Sáng",
  "High Contrast": "Tương phản Cao",
  "High Saturation": "Bão hòa Cao",
  "Low Saturation": "Bão hòa Thấp",
  "Monochrome": "Đơn sắc",
  "Contrast": "Độ tương phản",
  "Invert Colors": "Đảo ngược màu",
  "Tools": "Công cụ",
  "Reading Guide": "Hướng dẫn Đọc",
  "Stop Animations": "Dừng Hoạt hình",
  "Big Cursor": "Con trỏ Lớn",
  "Increase Font Size": "Tăng Kích thước Font chữ",
  "Decrease Font Size": "Giảm Kích thước Font chữ",
  "Letter Spacing": "Khoảng cách Chữ",
  "Line Height": "Độ Cao dòng",
  "Font Weight": "Độ Đậm của Font chữ",
  "Dyslexia Font": "Font chữ Cho người có Khuyết tật đọc hiểu",
  "Language": "Ngôn ngữ",
  "Open Accessibility Menu": "Mở Menu Truy cập",
  "Widget Settings": "Cài đặt tiện ích",
  "Widget Position": "Vị trí tiện ích",
  "Top Left": "Trên bên trái",
  "Top Center": "Trên giữa",
  "Top Right": "Trên bên phải",
  "Center Left": "Giữa bên trái",
  "Center Right": "Giữa bên phải",
  "Bottom Left": "Dưới bên trái",
  "Bottom Center": "Dưới giữa",
  "Bottom Right": "Dưới bên phải",
  "Screen Reader": "Trình đọc màn hình",
  "Voice Navigation": "Dẫn đường bằng giọng nói",
  "Custom Color": "Màu tùy chỉnh",
  "Change the site's colors": "Thay đổi màu của trang",
  "Backgrounds": "Hình nền",
  "Headings": "Tiêu đề",
  "Contents": "Nội dung",
  "Reset colors": "Đặt lại màu",
  "Image Desaturation": "Giảm độ bão hòa ảnh",
  "Search languages": "Tìm kiếm ngôn ngữ",
  "No languages found": "Không tìm thấy ngôn ngữ nào",
  "Accessibility Profiles": "Hồ sơ trợ năng",
  "Motor Impaired": "Hỗ trợ vận động",
  "Big cursor, voice navigation, and no animations.": "Con trỏ lớn, điều hướng giọng nói và không hoạt ảnh.",
  "Blind": "Khiếm thị",
  "Screen reader helpers with higher contrast.": "Trợ lý trình đọc màn hình với độ tương phản cao hơn.",
  "Color Blind": "Mù màu",
  "High contrast palette with desaturated media.": "Bảng màu tương phản cao với phương tiện giảm bão hòa.",
  "Dyslexia": "Chứng khó đọc",
  "Friendly font, extra spacing, stronger weight.": "Phông chữ dễ đọc, khoảng cách rộng và nét chữ đậm hơn.",
  "Low vision": "Thị lực kém",
  "Dark contrast and 130% magnification.": "Độ tương phản tối và phóng to 130%.",
  "Cognitive & Learning": "Nhận thức & học tập",
  "Highlights key sections and enables voice help.": "Làm nổi bật phần quan trọng và bật trợ lý giọng nói.",
  "Seizure & Epileptic": "Co giật & động kinh",
  "Stops animations and desaturates imagery.": "Dừng hoạt ảnh và giảm bão hòa hình ảnh.",
  "ADHD": "ADHD",
  "Reading guide, highlighted links, calmer palette.": "Hướng dẫn đọc, liên kết nổi bật và bảng màu dịu hơn.",
  "Widget Size": "Kích thước tiện ích",
  "Default": "Mặc định",
  "Medium": "Vừa",
  "Small": "Nhỏ",
  "Color Blindness": "Mù màu",
  "Protanopia": "Mù màu đỏ",
  "Deuteranopia": "Mù màu xanh lá",
  "Tritanopia": "Mù màu xanh dương",
  "Achromatopsia": "Mù màu hoàn toàn",
  "Simulates and assists users with color vision deficiencies.": "Mô phỏng và hỗ trợ người dùng bị suy giảm thị lực màu sắc."
}
